"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.processList = exports.orderPayStatus_szxq = exports.orderPayStatus = exports.motto = exports.maintain_form_rules = exports.default = exports.OA_step01_form_rules = exports.OA_status_front = exports.OA_status_backend = void 0;
// 产品功能迭代
var processList = exports.processList = [{
  name: '顺丰',
  time: 'SF',
  version: ''
}];
var motto = exports.motto = ['我会为我的理想去奋斗。', '我深知我不努力什么都不是。', '只有不停的跑才能追上我的梦。', '总有一天你会成为你想成为的人。', '生活就是一场逃亡，不能坐以待毙。', '即使跌倒了，也要漂亮的站起来再哭。', '志在山顶的人，不会贪念山腰的风景。', '我要做的是跌入深渊但依旧傲然挺立的王者。', '贫穷不能等，等久了，自己将会习惯于贫穷。', '真正的勇气不是压倒一切，而是不被一切压倒。', '想要的东西必须自己拿，不然就算别人给你也要不起', '生活不是等待风暴过去，而是学会在雨中翩翩起舞。', '当世界给草籽重压时，它总会用自己的方法破土而出。', '一个人的心房要承载多少毁灭，才会遇到另一颗复活它的心。', '孤独不是给别人机会来可怜你，而是给你机会发现更强大的自己。', '在喜欢你的人那里，去热爱生活；在不喜欢你的人那里，去看清世界。', '把艰辛的劳作看作是生命的必然，即使没有收获的希望也心平气和的继续。', '花开有时，花落有时。无需留恋，该走的终会走；无需苛求，该来的迟早会来', '每个人的人生都是不一样的，处同样的位置，也是有人哭，有人笑，有人沉默。', '前有阻碍，奋力把它冲开，运用炙热的**，转动心中的期待，血在澎湃，吃苦流汗算什么。', '有些东西，并不是越浓越好，要恰到好处。深深的话我们浅浅地说，长长的路我们慢慢地走。', '我们需要一点点的眼泪去洗掉眼中的迷雾，一点点的拥抱去疗愈受伤的心，一点点的休息去继续前行。', '没实力的愤怒毫无意义。', '你只管负责精彩上帝自有安排', '自己不努力靠什么来拼未来。', '读书，这是为了遇见更好的自己', '自己选择的路，跪着也要把它走完。', '宁可被人笑一时，不可被人笑一辈子。', '流过泪的眼睛更明亮，滴过血的心灵更坚强！', '所谓的人生就是心再疼也要爬起来面带微笑的走', '我爸我妈不是老板我不是富二代所以我的未来必须靠自己', '别总怪谁，如果你足够好，又怎么可能是那个被丢下的人？', '我不去想是否能够成功，既然选择了远方，便只顾风雨兼程！', '带着感恩的心启程，学会爱，爱父母，爱自己，爱朋友，爱他人。', '踏进社会你要懂，你从此什么都会拥有，但拥有不了一个稳定的将来。', '生命中最好的事情就是那些值得的等待，值得为之奋斗，也值得永不放弃。', '这个社会是存在不公平的，不要抱怨，因为没有用！人总是在反省中进步的！', '不要轻易用过去来衡量生活的幸与不幸！每个人的生命都是可以绽放美丽，只要你珍惜。', '只有经历过地狱般的折磨，才有征服天堂的力量，只有流过血的手指，才能弹出世间的绝唱。', '未来不迎，过往不恋，当下的每一个瞬间，就是生命的唯一瞬间。活好了当下，就活好了一生。', '奇迹是努力的另一个名字', '爱自己，靠自己，做自己', '与其顾虑太多，倒不如放手一搏', '你不能改变过去但你可以改变未来', '不为失败找理由，只为成功找方法。', '别总是无所事事，总有一天你会后悔。', '将来的你一定会感激现在拼命的自己。', '人生只有走出来的美丽，没有等出来的辉煌。', '王者的路必定坎坷请踏平荆棘走向王者的宝座', '放下已经走远的人与事，放下早已尘封的是与非', '记住！永远不要做一个摔一跤就站不起来的人。', '爱自己的最好方式，就是努力奋斗让自己优秀起来。', '人活着不是要用眼泪博得同情，而是用汗水赢得掌声。', '用微笑告诉别人，今天的我，比昨天更强，今后也一样。', '穷则思变，差则思勤！没有比人更高的山没有比脚更长的路。', '走过了所有的路，才知道幸福是用来感受的，伤痛是用来成长的。', '比我差的人还没放弃，比我好的人仍在努力，我就更没资格说，我无能为力！', '不要去考虑自己能够走多快，只要知道自己在不断努力向前就行，路对了，成功就不远了。'];

// 前店OA各个节点状态
var OA_status_front = exports.OA_status_front = [
// { name: '已注册', id: '1', children: [{ name: '未认证', id: '10' }, { name: '未开通', id: '1' }] },
{
  name: '未开通',
  id: '1',
  children: [{
    name: '未开通',
    id: '1'
  }]
}, {
  name: '资料报批',
  id: '2',
  children: [{
    name: '待提交',
    id: '2'
  }, {
    name: '待初审',
    id: '3'
  }, {
    name: '待复审',
    id: '4'
  }, {
    name: '已通过',
    id: '5'
  }]
}, {
  name: '商务签约',
  id: '3',
  children: [{
    name: '待提交',
    id: '6'
  }, {
    name: '待签约',
    id: '7'
  }, {
    name: '待签署',
    id: '8'
  }, {
    name: '待审核',
    id: '9'
  }, {
    name: '已审核',
    id: '10'
  }]
}, {
  name: '开店配货',
  id: '4',
  children: [{
    name: '待提交',
    id: '11'
  }, {
    name: '待初审',
    id: '12'
  }, {
    name: '待复审',
    id: '13'
  }, {
    name: '待出库',
    id: '14'
  }, {
    name: '已出库待确认',
    id: '15'
  }, {
    name: '已出库已确认',
    id: '16'
  }]
}, {
  name: '陈列审核',
  id: '5',
  children: [{
    name: '已确认待回传',
    id: '17'
  }, {
    name: '已回传待审核',
    id: '18'
  }, {
    name: '已回传已审核',
    id: '19'
  }]
}, {
  name: '已开通',
  id: '6',
  children: [{
    name: '正常经营',
    id: '20'
  }]
}, {
  name: '撤店管控',
  id: '7',
  children: [{
    name: '撤店管控',
    id: '21'
  }]
}, {
  name: '公司管控',
  id: '8',
  children: [{
    name: '公司管控',
    id: '22'
  }]
}, {
  name: '已闭店',
  id: '9',
  children: [{
    name: '合作管控',
    id: '24'
  }, {
    name: '合作到期',
    id: '23'
  }]
}];
//
var OA_status_backend = exports.OA_status_backend = [
// { name: '已注册', id: '1', children: [{ name: '未认证', id: '10' }, { name: '未开通', id: '1' }] },
{
  name: '未开通',
  id: '1',
  children: [{
    name: '未开通',
    id: '1'
  }]
}, {
  name: '资料报批',
  id: '2',
  children: [{
    name: '待提交',
    id: '2'
  }, {
    name: '待初审',
    id: '3'
  }, {
    name: '待复审',
    id: '4'
  }, {
    name: '已通过',
    id: '5'
  }]
}, {
  name: '商务签约',
  id: '3',
  children: [{
    name: '待提交',
    id: '6'
  }, {
    name: '待签约',
    id: '7'
  }, {
    name: '待签署',
    id: '8'
  }, {
    name: '待审核',
    id: '9'
  }, {
    name: '已审核',
    id: '10'
  }]
}, {
  name: '开店配货',
  id: '4',
  children: [{
    name: '待提交',
    id: '11'
  }, {
    name: '待初审',
    id: '12'
  }, {
    name: '待复审',
    id: '13'
  }, {
    name: '待出库',
    id: '14'
  }, {
    name: '已出库待确认',
    id: '15'
  }, {
    name: '已出库已确认',
    id: '16'
  }]
}, {
  name: '已开通',
  id: '6',
  children: [{
    name: '正常经营',
    id: '20'
  }]
}, {
  name: '撤店管控',
  id: '7',
  children: [{
    name: '撤店管控',
    id: '21'
  }]
}, {
  name: '公司管控',
  id: '8',
  children: [{
    name: '公司管控',
    id: '22'
  }]
}, {
  name: '已闭店',
  id: '9',
  children: [{
    name: '合作管控',
    id: '24'
  }, {
    name: '合作到期',
    id: '23'
  }]
}];

// oa资料报批 form表单验证字段
var OA_step01_form_rules = exports.OA_step01_form_rules = {
  fileList01: {
    required: true,
    message: '营业执照不可为空！',
    trigger: 'change'
  },
  companyName: {
    required: true,
    message: '工商名称不可为空！',
    trigger: 'change'
  },
  legalPerson: {
    required: true,
    message: '法人姓名不可为空！',
    trigger: 'change'
  },
  businessLicense: {
    required: true,
    message: '三证合一不可为空！',
    trigger: 'change'
  },
  companyAddress: {
    required: true,
    message: '注册地址不可为空！',
    trigger: 'change'
  },
  fileList02: {
    required: true,
    message: '身份证人像面不可为空！',
    trigger: 'change'
  },
  fileList03: {
    required: true,
    message: '身份证国徽面不可为空！',
    trigger: 'change'
  },
  idName: {
    required: true,
    message: '用户姓名不可为空！',
    trigger: 'change'
  },
  idNo: {
    required: true,
    message: '身份证号不可为空！',
    trigger: 'change'
  },
  receiptPersonName: {
    required: true,
    message: '收件人名不可为空！',
    trigger: 'change'
  },
  receiptMobile: {
    required: true,
    message: '收件人联系方式不可为空！',
    trigger: 'change'
  },
  district: {
    required: true,
    message: '收货地址不可为空！',
    trigger: 'change'
  },
  receiptAddress: {
    required: true,
    message: '详细地址不可为空！',
    trigger: 'change'
  },
  shelvesNum: {
    required: true,
    message: '货架数量不可为空！',
    trigger: 'change'
  },
  shelvesWidth: {
    required: true,
    message: '货架宽度不可为空！',
    trigger: 'change'
  },
  shelvesLevel: {
    required: true,
    message: '货架层数不可为空！',
    trigger: 'change'
  },
  shelvesType: {
    required: true,
    message: '货架商品不可为空！',
    trigger: 'change'
  },
  fileList04: {
    required: true,
    message: '门头照片不可为空！',
    trigger: 'change'
  },
  fileList05: {
    required: true,
    message: '货架照片不可为空！',
    trigger: 'change'
  },
  turnover: {
    required: true,
    message: '营业额不可为空！',
    trigger: 'change'
  },
  planTurnover: {
    required: true,
    message: '预计营业额不可为空！',
    trigger: 'change'
  }
};

// 前店维护节点
var maintain_form_rules = exports.maintain_form_rules = [{
  name: '维护盘存',
  id: '20',
  children: [{
    name: '待签到',
    id: '1'
  }, {
    name: '待确认',
    id: '2'
  }, {
    name: '待盘存',
    id: '3'
  }, {
    name: '待审核',
    id: '4'
  }, {
    name: '已盘存',
    id: '5'
  }]
}, {
  name: '回款/结算',
  id: '21',
  children: [{
    name: '待结算',
    id: '6'
  }, {
    name: '已结算',
    id: '7'
  }]
}, {
  name: '维护退库',
  id: '22',
  children: [{
    name: '待退货',
    id: '8'
  }, {
    name: '已入库',
    id: '9'
  }]
}, {
  name: '维护补货',
  id: '23',
  children: [{
    name: '无补货',
    id: '10'
  }, {
    name: '已补货',
    id: '11'
  }]
}];

// 订单支付状态
var orderPayStatus = exports.orderPayStatus = ['待支付', '已支付', '已逾期未结款', '已逾期已结款', '待结款', '已结款', '待转账'];
// 订单支付状态 四爪星球
// @ApiModelProperty(value = "订单状态 1-待提交 2-待初审 3-待复审  4-待拣货 5-待出库  6-已出库  7-待收货 8-已签收 9-已完成  10-退款中 11-已取消/关闭")
var orderPayStatus_szxq = exports.orderPayStatus_szxq = ['', '待付款', '待初审', '待复审', '待拣货', '待出库', '已出库', '待收货', '已签收', '已完成', '退款中', '已取消/关闭'];
var _default = exports.default = {
  processList: processList,
  motto: motto,
  OA_status_front: OA_status_front,
  OA_status_backend: OA_status_backend,
  OA_step01_form_rules: OA_step01_form_rules,
  maintain_form_rules: maintain_form_rules,
  orderPayStatus: orderPayStatus,
  orderPayStatus_szxq: orderPayStatus_szxq
};